export default {
  greys: {
    white: '#ffffff',
    smoke: '#f5f5f5',
    gallery: '#eeeeee',
    stone: '#cccccc',
    'dark-grey': '#bbb',
    silver: '#aaaaaa',
    'dark-stone': '#999',
    grey: '#757575',
    mortar: '#474747',
    black: '#24272e',
  },
  blues: {
    'pale-blue': '#f1f5f9',
    oyster: '#dfe9f2',
    'dark-vivid': '#cadbef',
    spindle: '#a8c5e8',
    'dark-midnight': '#9ac8ff',
    danube: '#3D74B8',
    vivid: '#31609b',
    'dark-pale-blue': '#22384F',
    midnight: '#191654',
  },
  teals: {
    mint: '#ecf8f5',
    fountain: '#95c9cc',
    'dark-aquamarine': '#3DC7B0',
    aquamarine: '#35b6a0',
    'dark-atoll': '#2DADB3',
    'atoll-icons': '#009999',
    atoll: '#00888f',
    moss: '#00656A',
    'dark-mint': '#435655',
  },
  reds: {
    'dark-espresso': '#ffedef',
    floral: '#fde3e4',
    cupid: '#FAC8CC',
    blush: '#ff979c',
    watermelon: '#fb646b',
    amaranth: '#f0414a',
    'dark-blush': '#953e42',
    rust: '#A2454A',
    stiletto: '#742528',
    espresso: '#551619',
  },
  yellows: {
    bisque: '#fdebd6',
    apricot: '#fbd7ad',
    saffron: '#f7b05b',
    orange: '#FE9C51',
    'dark-saffron': '#ac8951',
    'dark-apricot': '#946a31',
    'dark-bisque': '#704d1d',
    kumera: '#766643',
    bean: '#694721',
    punga: '#553816',
  },
}
